import { z } from "zod";

export const pinSchema = z.string().regex(/^\d{4,6}$/, "O PIN tem de 4 a 6 números.");

/** Criar ou trocar o PIN. Trocar exige o PIN atual — ou a senha da conta, pra quem esqueceu. */
export const definirPinSchema = z.object({
  pin: pinSchema,
  pinAtual: z.string().optional(),
  senha: z.string().optional(),
});
export type DefinirPinInput = z.infer<typeof definirPinSchema>;

export const confirmarPinSchema = z.object({ pin: z.string().min(1) });
export type ConfirmarPinInput = z.infer<typeof confirmarPinSchema>;
